// Параметры плеера kuula: без логотипа и подсказок, с фуллскрином и VR,
// sd=0 — панорамы в исходном качестве (ATLA-605)
const PANORAMA_PLAYER_PARAMS: Record<string, string> = {
  logo: "-1",
  info: "0",
  fs: "1",
  vr: "1",
  zoom: "1",
  sd: "0",
  audio: "0",
  thumbs: "-1",
  inst: "ru",
};

/**
 * В админке лежит «голая» ссылка на панораму — параметры плеера дописываем сами
 * и не трогаем те, что уже проставлены руками (в ссылке проекта, например, стоит sd=1).
 * Не URL — отдаём как есть, чтобы кривая ссылка не роняла страницу.
 */
export const buildPanoramaEmbedUrl = (raw?: string | null): string | null => {
  const value = raw?.trim();
  if (!value) return null;

  try {
    const url = new URL(value);
    Object.entries(PANORAMA_PLAYER_PARAMS).forEach(([key, param]) => {
      if (!url.searchParams.has(key)) url.searchParams.set(key, param);
    });
    return url.toString();
  } catch {
    return value;
  }
};
